import { Text, Tag, TagLeftIcon, TagRightIcon } from '@chakra-ui/react';
import { FilterLines } from '@kula-ai/icons/outline/FilterLines';
import { ChevronDown } from '@kula-ai/icons/outline/ChevronDown';
import { useKFlags } from '@/hooks/use-k-flags';

interface FilterTriggerProps {
  onClick: () => void;
  triggerText: string;
}

export const FilterTrigger = ({
  onClick,
  triggerText = 'Filters',
}: FilterTriggerProps) => {
  const { feReportsV3 } = useKFlags();

  const tagProps = feReportsV3
    ? { height: '32px', p: '8px', background: 'primary-50' }
    : { height: '36px', p: '0', background: 'inherit' };

  return (
    <Text as="a">
      <Tag cursor="pointer" onClick={onClick} as="a" {...tagProps}>
        <TagLeftIcon
          as={FilterLines}
          color="primary-600"
          width="16px"
          height="16px"
        />
        <Text size="sm-medium" color="primary-600">
          {triggerText}
        </Text>
        <TagRightIcon as={ChevronDown} color="primary-600" />
      </Tag>
    </Text>
  );
};
